export default __webpack_public_path__ + "static/solution-dba33c7130bfbb297e7269981948ed92.png";